// Thu Mar 27 06:04:36 GMT 2025

import * as models from "../crm-web-api-models"

export enum BankAccountProp {
	AccountNumber = 'accountNumber',
	BankAddress = 'bankAddress',
	BankCode = 'bankCode',
	BankName = 'bankName',
	BeneficiaryName = 'beneficiaryName',
	BranchCode = 'branchCode',
	Country = 'country',
	Currency = 'currency',
	Description = 'description',
	Iban = 'iban',
	Id = 'id',
	Name = 'name',
	PaymentAccountStatus = 'paymentAccountStatus',
	RelatedEntity$customerFullName = 'relatedEntity$customerFullName',
	RelatedEntityId = 'relatedEntity.id',
	Swift = 'swift'
}

export type BankAccountPropAccountNumber = {
	[BankAccountProp.AccountNumber] : string | null
}
export type BankAccountPropBankAddress = {
	[BankAccountProp.BankAddress] : string | null
}
export type BankAccountPropBankCode = {
	[BankAccountProp.BankCode] : string | null
}
export type BankAccountPropBankName = {
	[BankAccountProp.BankName] : string | null
}
export type BankAccountPropBeneficiaryName = {
	[BankAccountProp.BeneficiaryName] : string | null
}
export type BankAccountPropBranchCode = {
	[BankAccountProp.BranchCode] : string | null
}
export type BankAccountPropCountry = {
	[BankAccountProp.Country] : 'NA' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOSOVO' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type BankAccountPropCurrency = {
	[BankAccountProp.Currency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type BankAccountPropDescription = {
	[BankAccountProp.Description] : string | null
}
export type BankAccountPropIban = {
	[BankAccountProp.Iban] : string | null
}
export type BankAccountPropId = {
	[BankAccountProp.Id] : number
}
export type BankAccountPropName = {
	[BankAccountProp.Name] : string | null
}
export type BankAccountPropPaymentAccountStatus = {
	[BankAccountProp.PaymentAccountStatus] : 'PENDING' | 'APPROVED' | 'REJECTED' | 'BLACK_LISTED' | 'REVOKE_PENDING' | null
}
export type BankAccountPropRelatedEntity$customerFullName = {
	[BankAccountProp.RelatedEntity$customerFullName] : any /* Entity */
}
export type BankAccountPropRelatedEntityId = {
	[BankAccountProp.RelatedEntityId] : number | null
}
export type BankAccountPropSwift = {
	[BankAccountProp.Swift] : string | null
}


export type BankAccount = 
	BankAccountPropAccountNumber & 
	BankAccountPropBankAddress & 
	BankAccountPropBankCode & 
	BankAccountPropBankName & 
	BankAccountPropBeneficiaryName & 
	BankAccountPropBranchCode & 
	BankAccountPropCountry & 
	BankAccountPropCurrency & 
	BankAccountPropDescription & 
	BankAccountPropIban & 
	BankAccountPropId & 
	BankAccountPropName & 
	BankAccountPropPaymentAccountStatus & 
	BankAccountPropRelatedEntity$customerFullName & 
	BankAccountPropRelatedEntityId & 
	BankAccountPropSwift

export const BANK_ACCOUNT_PROPERTY_NAMES = Object.freeze([BankAccountProp.AccountNumber, BankAccountProp.BankAddress, BankAccountProp.BankCode, BankAccountProp.BankName, BankAccountProp.BeneficiaryName, BankAccountProp.BranchCode, BankAccountProp.Country, BankAccountProp.Currency, BankAccountProp.Description, BankAccountProp.Iban, BankAccountProp.Id, BankAccountProp.Name, BankAccountProp.PaymentAccountStatus, BankAccountProp.RelatedEntity$customerFullName, BankAccountProp.RelatedEntityId, BankAccountProp.Swift])

export type BankAccountCreate = 
	BankAccountPropRelatedEntityId & 
	BankAccountPropBeneficiaryName & 
	BankAccountPropName & 
	BankAccountPropCurrency & 
	BankAccountPropAccountNumber & 
	BankAccountPropIban & 
	BankAccountPropDescription & 
	BankAccountPropBankName & 
	BankAccountPropCountry & 
	BankAccountPropBankAddress & 
	BankAccountPropSwift & 
	BankAccountPropBankCode & 
	BankAccountPropBranchCode

export const BANK_ACCOUNT_CREATE_PROPERTY_NAMES = Object.freeze([BankAccountProp.RelatedEntityId, BankAccountProp.BeneficiaryName, BankAccountProp.Name, BankAccountProp.Currency, BankAccountProp.AccountNumber, BankAccountProp.Iban, BankAccountProp.Description, BankAccountProp.BankName, BankAccountProp.Country, BankAccountProp.BankAddress, BankAccountProp.Swift, BankAccountProp.BankCode, BankAccountProp.BranchCode])

export type BankAccountTab = 
	BankAccountPropId & 
	BankAccountPropName & 
	BankAccountPropRelatedEntity$customerFullName

export const BANK_ACCOUNT_TAB_PROPERTY_NAMES = Object.freeze([BankAccountProp.Id, BankAccountProp.Name, BankAccountProp.RelatedEntity$customerFullName])

export type BankAccountHeader = 
	BankAccountPropId & 
	BankAccountPropName & 
	BankAccountPropRelatedEntityId & 
	BankAccountPropRelatedEntity$customerFullName

export const BANK_ACCOUNT_HEADER_PROPERTY_NAMES = Object.freeze([BankAccountProp.Id, BankAccountProp.Name, BankAccountProp.RelatedEntityId, BankAccountProp.RelatedEntity$customerFullName])

export type BankAccountInformation = 
	BankAccountPropId & 
	BankAccountPropName & 
	BankAccountPropBeneficiaryName & 
	BankAccountPropCurrency & 
	BankAccountPropRelatedEntityId & 
	BankAccountPropRelatedEntity$customerFullName & 
	BankAccountPropAccountNumber & 
	BankAccountPropIban & 
	BankAccountPropDescription & 
	BankAccountPropPaymentAccountStatus & 
	BankAccountPropBankName & 
	BankAccountPropCountry & 
	BankAccountPropBankAddress & 
	BankAccountPropSwift & 
	BankAccountPropBankCode & 
	BankAccountPropBranchCode

export const BANK_ACCOUNT_INFORMATION_PROPERTY_NAMES = Object.freeze([BankAccountProp.Id, BankAccountProp.Name, BankAccountProp.BeneficiaryName, BankAccountProp.Currency, BankAccountProp.RelatedEntityId, BankAccountProp.RelatedEntity$customerFullName, BankAccountProp.AccountNumber, BankAccountProp.Iban, BankAccountProp.Description, BankAccountProp.PaymentAccountStatus, BankAccountProp.BankName, BankAccountProp.Country, BankAccountProp.BankAddress, BankAccountProp.Swift, BankAccountProp.BankCode, BankAccountProp.BranchCode])
